import { State } from '@/components/atoms/state';
import { ClipboardList } from 'lucide-react';

export const TransactionsEmptyState = () => {
  return (
    <div className="w-full h-[82vh] flex flex-col items-center justify-center py-20 bg-white rounded-xl">
      <State
        heading="You don't have any recent transactions"
        Icon={ClipboardList}
      />
    </div>
  );
};
